import ReactDOM from 'react-dom';
import React, { Component, useEffect, useState } from 'react';
import { component } from 'picoapp'
import { QueryClient, QueryClientProvider, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { useCartUpdate,useCartContents, cartMutation} from '@src/hooks';
import pluralize from 'pluralize';
import Card from './card'
import LoadingSpinner from '../../parts/LoadingSpinner';

import './style.scss'

const queryClient = new QueryClient();

const ColorMatchKitWrapper = ({appstate, node}) => {
  return(
    <QueryClientProvider client={queryClient}>
      <ColorMatchKit appstate={appstate} node={node} />
    </QueryClientProvider>
  )
}

const ColorMatchKit = ({appstate, node}) => {
  const { status, data: cartContents, error, isLoading } = useCartContents();
  const [data, setData ] = useState(null)
  const [cart, setCart ] = useState(null)
  const [tryOnCount, setTryOnCount ] = useState(0);
  const addToCart = cartMutation();
  const updateCart = useCartUpdate();

  useEffect(() => {
    setData(JSON.parse(node.parentNode.querySelector('[data-section-json]').text));
    appstate.on('cart.update', (state) => {
      queryClient.invalidateQueries('cart');
    });
  },[])

  useEffect(() => {
    if(cartContents){
      setCart(cartContents);
    }
  },[cartContents])

  useEffect(() => {
    if(cart){
      const count = cart.items.filter( p => p.product_type === 'Try On').length
      setTryOnCount(count)
    }
  }, [cart])

  useEffect(() => {
    
  },[tryOnCount])

  const handleAddToCart = (productId) => {
    const payload = {
      id: productId,
      quanity: 1
    }
    addToCart
        .mutateAsync({
          items: [
            payload
          ],
        })
        .then((response) => {
          appstate.emit('cart.update');
        })
        .catch((error) => {
          console.error(error);
        });
  }

  const handleRemoveFromCart = (productId) => {
    const payload = {
      [productId]: 0
    }
    updateCart.mutateAsync({ updates: payload }).then((response) => appstate.emit('cart.update'));
  }

  if (isLoading) {
    return <LoadingSpinner></LoadingSpinner>;
  }
  
  return (
    <>
      {data && data.map(category => (
        <div id={category.handle} key={category.handle} className="Section Section--category">
          <div className="Section__header">
            <h3 className="heading">{category.title}</h3>	
          </div>
          <div className="Section__content">
            <div className="Loop Loop--try-on">
              {category.products.map(product => (
                <Card 
                  product={product} 
                  added={cart?.items.some( p => p.handle === product.handle) ? true : false } 
                  tryOnCount={tryOnCount}
                  addToCart={handleAddToCart} 
                  removeFromCart={handleRemoveFromCart}
                  key={product.handle} />
              ))}
            </div>
          </div>
        </div>    
      ))}
      <div className={`cmkInfo ${tryOnCount > 0 && 'is-active'}`}> 
        <p>You have selected {tryOnCount} of 5 {pluralize('sample', tryOnCount)}.</p>
        <a href="/cart" className="Button" data-style="underline white" >View Cart</a>
      </div>
    </>
  )
  
}

export default component((node, ctx) => {
  const element = <ColorMatchKitWrapper appstate={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});